export default __webpack_public_path__ + "static/media/filters2.c000e78b.svg";